import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Pagination, Navigation]);
import seeAll from "../seeAll";

const initCasesSlider = () => {
  const slider = document.querySelector(".newCases__slider");

  new Swiper(slider, {
    autoHeight: false,
    lazy: true,
    breakpoints: {      
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: true,
      },
    },
    navigation: {
      nextEl: ".newCasesPagination__pagination-next",
      prevEl: ".newCasesPagination__pagination-prew",
      disabledClass: "last",
    },

    on: {
      init: function () {
        seeAll(this.activeIndex);
        const totalSlides = this.slides.length;
        document.querySelector(".newCasesPagination__total").innerHTML =
          totalSlides;
        document.querySelector(".newCasesPagination__count").innerHTML = 1;
      },
      activeIndexChange: function () {
        seeAll(this.activeIndex);
      },
      slideChange: function () {
        const index_currentSlide = this.realIndex + 1;
        document.querySelector(".newCasesPagination__count").innerHTML =
          index_currentSlide;
      },
    },
  });
};

export default initCasesSlider;
